var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuetify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 384,
    viewBox: "0 0 432 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.897 103.248L146.523 230.363L216 350.772L308.021 191.386L400 32H261.005L219.897 103.248Z",
    fill: "#1697F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.021 191.386L128.84 199.768L197.478 80.8258L225.68 32H216H32L124.021 191.386Z",
    fill: "#AEDDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.005 32C295.785 146.458 216 350.772 216 350.772L146.523 230.363L261.005 32Z",
    fill: "#1867C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.68 32C79.1426 32 128.84 199.768 128.84 199.768L225.68 32Z",
    fill: "#7BC6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuetify);
export default __webpack_public_path__ + "static/media/vuetify.bbf7cb41c1a373da720a5da344781803.svg";
export { ForwardRef as ReactComponent };